import { Children } from "react";
import styled from "styled-components";

export const MenuItem = styled.div`
  display: flex;
  padding: 8px;
  flex-direction: row;
  list-style: none;
`;

export interface NavigationSectionProps
  extends React.ComponentPropsWithoutRef<"ul"> {
  justify?: "start" | "end";
}

export const MobileNavigationSection = ({
  children,
}: NavigationSectionProps) => (
  <>
    {Children.map(children, (child) => {
      if (!child) return null;
      return <MenuItem role="presentation">{child}</MenuItem>;
    })}
  </>
);
